// Standard library imports
import React, { useState, useEffect } from 'react';

// External library imports
import { useLocation } from 'react-router-dom';
// Internal module imports
import classes from './index.module.css';
import TabsComponent from '../../components/Tabs/Tabs';
import { useQueryParamWithDefault } from '../../hooks';
import { AFRR_MARKET_TYPES, FCR_D_N_NMMS, MFRR_MARKET_TYPES } from '../../constants';
import { MasterBidding } from '../Reusables/Bidding/MasterBidding/bidding';
import { BundleBid } from '../Reusables/Bidding/BundleBidding/BundleBid';
import { BidRequest } from '../Reusables/Bidding/BidRequest/BidRequest';
import { NumberParam } from 'use-query-params';
import TotalCapacity from '../Reusables/Bidding/TotalCapacity';

const MARKET_MAP = {
    'fcr-d-inc': 'FCR-D-INC',
    'fcr-d-minus': 'FCR-D-DEC',
    'fcr-d-se3-inc': 'FCR-D-SE3-INC',
    fcr: 'FCR',
    ffr: 'FFR',
    afrr: 'aFRR',
    mfrr: 'mFRR',
    'afrr-dk1-inc': 'aFRR-DK1-INC',
    'afrr-dk1-dec': 'aFRR-DK1-DEC',
    'afrr-dk2-inc': 'aFRR-DK2-INC',
    'afrr-dk2-dec': 'aFRR-DK2-DEC',
    'mfrr-dk1-inc': 'mFRR-DK1-INC',
    'mfrr-dk1-dec': 'mFRR-DK1-DEC',
    'mfrr-dk2-inc': 'mFRR-DK2-INC',
    'mfrr-dk2-dec': 'mFRR-DK2-DEC',
    // 'fcr-d-dk2-inc': 'FCR-D-DK2-INC',
    // 'fcr-d-dk2-dec': 'FCR-D-DK2-DEC',
    'fcr-n-dk2': 'FCR-N-DK2',
};

const BiddingIndex = ({ cId }) => {
    const location = useLocation();
    const [market, setMarket] = useState(location.pathname.split('/')[2] ? MARKET_MAP[location.pathname.split('/')[2]] : '');

    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    useEffect(() => {
        setMarket(location.pathname.split('/')[2] ? MARKET_MAP[location.pathname.split('/')[2]] : '');
    }, [location]);

    let tabs = [
        {
            name: `${market} Bids`,
            component: (
                <>
                    <MasterBidding heading={`${market} bids`} indivisualMarket={{ status: true, market }} cId={cId} />
                </>
            ),
        },
        ...(['FCR-D-INC', 'FCR-D-DEC', 'FFR', ...FCR_D_N_NMMS, ...AFRR_MARKET_TYPES, ...MFRR_MARKET_TYPES].includes(market)
            ? [
                  {
                      name: 'Bundle Bids',
                      component: (
                          <>
                              <BundleBid heading={`${market} bids`} indivisualMarket={{ status: true, market }} cId={cId} />
                          </>
                      ),
                  },
              ]
            : []),
        ...(['FCR-D-INC', 'FCR-D-DEC', 'FFR', 'FCR', ...FCR_D_N_NMMS, ...AFRR_MARKET_TYPES, ...MFRR_MARKET_TYPES].includes(market)
            ? [
                  {
                      name: 'Bid Requests',
                      component: (
                          <>
                              <BidRequest indivisualMarket={{ status: true, market }} cId={cId} />
                          </>
                      ),
                  },
              ]
            : []),
        {
            name: 'Total Capacity',
            component: <TotalCapacity market={market} />,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default BiddingIndex;
